import { Pipe, PipeTransform } from '@angular/core'
import { Ultilities } from '../../extensions/ultilities'
/**
 * ### Đặt trong [innerHtml]="value | highlightText : searchValue"
 *
 * ### value: chuỗi cần đánh dấu
 *
 * ### searchValue: chuỗi đánh dấu
 *
 * ### option?: {class: string; checkLatin?: boolean; noUpperLower?: boolean} (Không bắt buộc)
 *
 * * #### option.class: Set css class cho chuỗi được đánh dấu. là field bắt buộc trong option. Mặc định là text-danger nếu để null hoặc ko điền option
 *
 * * #### option.checkLatin: kiểm tra giá trị đánh dấu bằng tiếng việt không dấu. Mặc định false
 *
 * * #### option.checkUpperLower: kiểm tra giá trị đánh dấu phân biệt chữ hoa chữ thường. Mặc định false
 */
@Pipe({
  name: 'vssUiHighlightText'
})
export class HighlightTextPipe implements PipeTransform {
  transform(value: string, searchValue: string, option: { class: string | null; checkLatin?: boolean; checkUpperLower?: boolean } = { class: 'text-danger' }): unknown {
    if (option.checkLatin) {
      return Ultilities.replaceEN(value || '', searchValue, `<span class="${!option?.class && option?.class != '' ? 'text-danger' : option?.class}">{{value}}</span>`)
    }

    return value.replace(
      new RegExp(searchValue.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), option?.checkUpperLower ? 'g' : 'gi'),
      (v) => `<span class="${!option?.class && option?.class != '' ? 'text-danger' : option?.class}">${v}</span>`
    )
  }

}
